import { styled } from '@linaria/react';

import { fonts, layout, semantic, space } from '../../theme/tokens';

export const PageWrapper = styled.section`
  width: 100%;
  max-width: ${layout.maxWidth};
  margin: 0 auto;
  padding: ${space['space-400']} ${space['space-400']} ${space['space-1200']};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${space['space-600']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space['space-1000']} ${space['space-1000']} ${space['space-2000']};
    gap: ${space['space-1000']};
  }
`;

export const HeadingRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
  margin-bottom: ${space['space-800']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    flex-direction: row;
    align-items: center;
  }
`;

export const BackButtonSlot = styled.div`
  display: flex;
`;

export const PageGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-800']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    flex-direction: row;
    align-items: flex-start;
    gap: ${space['space-1000']};
  }
`;

export const MainColumn = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${space['space-800']};
`;

export const SidebarColumn = styled.aside`
  display: none;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: block;
    width: 380px;
    flex-shrink: 0;
    position: sticky;
    top: ${space['space-600']};
  }
`;

export const MobileOnly = styled.div`
  @media (min-width: ${layout.desktopBreakpoint}) {
    display: none;
  }
`;

export const StepBlock = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
`;

export const StepTitle = styled.h2`
  display: flex;
  align-items: baseline;
  gap: ${space['space-200']};
  margin: 0;
  font-family: ${fonts.heading};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
`;

export const StepNumber = styled.span`
  font-family: ${fonts.heading};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
`;

export const StepHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space['space-300']};
`;

export const ExpressCheckoutBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
  margin-top: ${space['space-200']};
`;

export const ExpressCheckoutLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
  text-align: center;
`;

export const ExpressCheckoutDivider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${space['space-300']};
  color: ${semantic.text.secondary};
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: ${semantic.border.default};
  }
`;

export const SubmitButtonWrapper = styled.div`
  margin-top: ${space['space-400']};
`;

export const TermsLine = styled.p`
  margin: ${space['space-300']} 0 0;
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
  text-align: center;
`;

export const TermsLink = styled.a`
  color: ${semantic.text.primary};
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

export const SubmittingOverlay = styled.div<{ $active: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${space['space-1000']};
  pointer-events: ${({ $active }) => ($active ? 'none' : 'auto')};
  opacity: ${({ $active }) => ($active ? 0.5 : 1)};
`;
